// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-col {
  font-size: 0.9rem;
}

.info {
  color: #0063CF;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/deposit/deposit-wire/deposit-wire.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;AACJ","sourcesContent":["ion-col {\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.info {\r\n    color: #0063CF;\r\n    font-weight: 600;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
